<template>
  <ElementsSection :title="$t('rooms.features.title')">
    <Swiper
      :modules="[Navigation]"
      :navigation="{
        prevEl: '[data-carousel-button=features][data-carousel-button-prev]',
        nextEl: '[data-carousel-button=features][data-carousel-button-next]',
        disabledClass: 'disabled'
      }"
      :space-between="16"
      slides-per-view="auto"
      :breakpoints="{
        768: { spaceBetween: 28 },
        1024: { spaceBetween: 36 },
        1280: { spaceBetween: 40 }
      }"
      class="features overflow-visible"
    >
      <SwiperSlide v-for="(feature, index) in data?.features" :key="index" class="features-item select-none !w-auto min-w-25 lg:min-w-16 md:min-w-15">
        <div class="features-item__icon">
          <Icon :name="`sivene:${feature.icon}`" v-if="feature.icon" />
        </div>
        <div class="features-item__title" v-html="feature.name?.replaceAll('\\n', '<br>')"></div>
      </SwiperSlide>
    </Swiper>

    <template #actions>
      <ElementsCarouselButton name="features" />
    </template>
  </ElementsSection>
</template>

<script setup lang="ts">
  import { Swiper, SwiperSlide } from "swiper/vue"
  import { Navigation } from "swiper/modules"
  import "swiper/css"
  import "swiper/css/navigation"

  import fetchApi from "~/utils/fetchApi"

  const { data: responseData } = await useAsyncData("room-features", () =>
    fetchApi<any>("room-page", {
      wrappedByKey: "data",
      populate: {
        features: { populate: "*" }
      }
    })
  )

  const data = computed(() => responseData.value || {})
</script>

<style lang="scss" scoped>
  .features {
    &-item {
      @apply flex flex-col justify-center items-center text-center gap-4;
      color: #383838;

      &__icon {
        font-size: 56px;
      }
      &__title {
        @apply text-balance;
        font-size: 14px;
        font-weight: 400;
        line-height: 18px;
        letter-spacing: -0.28px;
      }

      &:not(.swiper-slide-visible) {
        @apply opacity-60;
      }
    }

    @include media("lg") {
      &-item {
        @apply gap-3;

        &__icon {
          font-size: 48px;
        }
        &__title {
          font-size: 13px;
          line-height: 16px;
          letter-spacing: -0.28px;
        }
      }
    }
    @include media("md") {
      &-item {
        @apply gap-2;

        &__icon {
          font-size: 44px;
        }
        &__title {
          font-size: 12px;
          line-height: 16px;
          letter-spacing: -0.16px;
        }
      }
    }
    @include media("sm") {
      @apply -mt-2;
    }
  }
</style>
